import React from 'react';

import * as styles from './DropzoneContent.module.css';

export function DropzoneContent({wipImage, savedImage}) {
  if (wipImage != null) {
    return (
      <>
        <div className={styles.Container}>
          <img src={wipImage} className={styles.Image} alt="" />
        </div>
        <p>Click 'Save' to upload this file.</p>
      </>
    );
  }

  if (savedImage != null) {
    return (
      <>
        <div className={styles.Container}>
          <img src={savedImage} className={styles.Image} alt="" />
        </div>
        <p>
          To replace this logo, drag and drop a new image here, or click to
          select files.
        </p>
      </>
    );
  }

  return <p>Drag and drop a logo here, or click to select files.</p>;
}
